import type {Ref} from "vue"

// Статуси, які віддає не бекенд, а шлюз перед ним (Render, Cloudflare 52x, dev-proxy Nitro — 503),
// коли сам бекенд недосяжний. Відповідь з таким статусом — це «нема зв'язку», а не помилка API.
const GATEWAY_STATUSES = [502, 503, 504, 520, 521, 522, 523, 524, 525, 526, 530]
export const isGatewayStatus = (status: number) => GATEWAY_STATUSES.includes(status)

// Стан зв'язку з сервером. Сигнали незалежні й ставляться з різних місць:
// - apiDown — запит до API не отримав відповіді взагалі або впав на шлюзі (isGatewayStatus), див. useApi;
// - realtimeDown — Centrifugo з уже встановленого з'єднання перейшов у перепідключення (свіжий
//   розрив, ловиться навіть коли застосунок нічого не запитує), див. plugins/centrifugo.client.ts;
// - missedUpdates — після перепідключення Centrifugo не зміг догнати пропущені повідомлення
//   (історія каналу коротша за розрив), тож частина даних на екрані застаріла.
// Будь-яка відповідь сервера знімає обидва «down»: сервер досяжний, решту доробить перепідключення.
export const useConnectionStatus = () => {
    const apiDown: Ref<boolean> = useState('connection:apiDown', () => false)
    const realtimeDown: Ref<boolean> = useState('connection:realtimeDown', () => false)
    const missedUpdates: Ref<boolean> = useState('connection:missedUpdates', () => false)

    return {
        apiDown,
        realtimeDown,
        missedUpdates,
        markServerReachable: () => {
            apiDown.value = false
            realtimeDown.value = false
        },
        markApiUnreachable: () => {
            apiDown.value = true
        },
        markRealtimeLost: () => {
            realtimeDown.value = true
        },
        markMissedUpdates: () => {
            missedUpdates.value = true
        },
    }
}
